if (!customElements.get('cedre-sku-quick-add')) {
  customElements.define(
    'cedre-sku-quick-add',
    class CedreSkuQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.openButton = this.querySelector('[data-sku-panel-open]');
        this.stickyWrap = this.querySelector('[data-sku-sticky]');
        this.stickyOpenButton = this.querySelector('[data-sku-sticky-open]');
        this.inlinePanel = this.querySelector('.cedre-sku-quick-add__panel--inline');
        this.modal = this.querySelector('[data-sku-modal]');
        this.closeButtons = this.querySelectorAll('[data-sku-panel-close]');
        this.addButtons = this.querySelectorAll('[data-sku-add-button]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.mobileMql = window.matchMedia('(max-width: 749px)');
        this.isPrimaryVisible = true;
        this.primaryObserver = null;
        this.footerObserver = null;
        this.footerSection =
          document.querySelector('#shopify-section-footer') ||
          document.querySelector('.shopify-section-group-footer-group') ||
          document.querySelector('footer');
        this.isFooterVisible = false;

        this.onEsc = this.handleEsc.bind(this);
        this.onViewportChange = this.handleViewportChange.bind(this);
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.wishlistDisplayTimer = null;
        this.bindEvents();
      }

      connectedCallback() {
        if (this.modal && !this.modal.dataset.portalMounted) {
          document.body.appendChild(this.modal);
          this.modal.dataset.portalMounted = 'true';
        }
        if (this.stickyWrap && !this.stickyWrap.dataset.portalMounted) {
          document.body.appendChild(this.stickyWrap);
          this.stickyWrap.dataset.portalMounted = 'true';
        }

        this.bindStickyObserver();
        this.bindFooterObserver();
        this.bindViewportListener();
        this.ensureWishlistButtons();
        this.refreshWishlistButtons();
        this.updateStickyVisibility();
      }

      disconnectedCallback() {
        if (this.modal && this.modal.parentNode === document.body) {
          this.modal.remove();
        }
        if (this.stickyWrap && this.stickyWrap.parentNode === document.body) {
          this.stickyWrap.remove();
        }

        if (this.primaryObserver) {
          this.primaryObserver.disconnect();
          this.primaryObserver = null;
        }
        if (this.footerObserver) {
          this.footerObserver.disconnect();
          this.footerObserver = null;
        }
        if (this.wishlistDisplayTimer) {
          window.clearTimeout(this.wishlistDisplayTimer);
          this.wishlistDisplayTimer = null;
        }

        document.removeEventListener('click', this.onDocumentClick);
        this.unbindViewportListener();
      }

      bindEvents() {
        if (this.openButton) {
          this.openButton.addEventListener('click', () => this.openPanel());
        }

        if (this.stickyOpenButton) {
          this.stickyOpenButton.addEventListener('click', () => this.openPanel());
        }

        this.closeButtons.forEach((button) => {
          button.addEventListener('click', () => this.closePanel());
        });

        this.addButtons.forEach((button) => {
          button.addEventListener('click', (event) => this.onAddToCart(event));
        });

        document.addEventListener('click', this.onDocumentClick);
      }

      handleDocumentClick(event) {
        if (!event || !event.target) return;
        const target = event.target;
        if (!(target instanceof Element)) return;

        const inScope =
          this.contains(target) ||
          (this.modal && this.modal.contains(target)) ||
          (this.stickyWrap && this.stickyWrap.contains(target));
        if (!inScope) return;

        if (event.cedreSkuQuickAddHandled) return;
        event.cedreSkuQuickAddHandled = true;

          const restockTrigger = event.target.closest('[data-restock-trigger]');
          if (restockTrigger) {
            event.preventDefault();
            const row = restockTrigger.closest('.cedre-sku-quick-add__row');
            if (!row) return;

            const wishlistProxy = row.querySelector(
              '.cedre-sku-quick-add__wishlist-slot a.wishlist-btn, .cedre-sku-quick-add__wishlist-slot a[data-wishlist], .cedre-sku-quick-add__wishlist-slot a[data-wishList]'
            );
            if (!wishlistProxy) return;

            const loginUrl = restockTrigger.dataset.restockLoginUrl;
            if (loginUrl) {
              wishlistProxy.click();
              window.setTimeout(() => {
                if (window.location.href.includes('/account/login')) return;
                window.location.href = loginUrl;
              }, 120);
              return;
            }

            const currentlyAdded = this.isWishlistAdded(wishlistProxy);
            wishlistProxy.dataset.cedreForceAdded = currentlyAdded ? '0' : '1';
            wishlistProxy.click();
            window.setTimeout(() => this.refreshWishlistButtons(), 80);
            return;
          }

          const wishlistButton = event.target.closest(
            '.cedre-sku-quick-add__actions a.wishlist-btn, .cedre-sku-quick-add__actions a[data-wishlist], .cedre-sku-quick-add__actions a[data-wishList]'
          );
          if (!wishlistButton) return;

          const currentlyAdded = this.isWishlistAdded(wishlistButton);
          wishlistButton.dataset.cedreForceAdded = currentlyAdded ? '0' : '1';
          window.setTimeout(() => this.refreshWishlistButtons(), 50);
      }

      openPanel() {
        if (!this.modal) return;
        this.modal.classList.add('is-open');
        document.addEventListener('keydown', this.onEsc);
        this.ensureWishlistButtons();
        this.refreshWishlistButtons();
        window.setTimeout(() => {
          this.ensureWishlistButtons();
          this.refreshWishlistButtons();
        }, 250);
        this.updateStickyVisibility();
      }

      ensureWishlistButtons() {
        const activeScope = this.getActiveWishlistScope();
        const inactiveScope = this.getInactiveWishlistScope();
        const rows = [...activeScope.querySelectorAll('.cedre-sku-quick-add__row[data-variant-id][data-product-id]')];
        const buttonSelector =
          '.cedre-sku-quick-add__actions a.wishlist-btn, .cedre-sku-quick-add__actions a[data-wishlist], .cedre-sku-quick-add__actions a[data-wishList]';

        rows.forEach((row) => {
          const actions = row.querySelector('.cedre-sku-quick-add__actions');
          const wishlistSlot = row.querySelector('.cedre-sku-quick-add__wishlist-slot');
          if (!actions) return;
          if (!wishlistSlot) return;
          if (wishlistSlot.querySelector('a.wishlist-btn, a[data-wishlist], a[data-wishList]')) return;

          const variantId = row.dataset.variantId;
          const productId = row.dataset.productId;
          if (!variantId || !productId) return;

          if (inactiveScope) {
            const movedButton = inactiveScope.querySelector(
              `.cedre-sku-quick-add__actions a[data-varID="${variantId}"], .cedre-sku-quick-add__actions a[data-varid="${variantId}"]`
            );
            if (movedButton) {
              wishlistSlot.appendChild(movedButton);
              return;
            }
          }

          const anchor = document.createElement('a');
          anchor.href = 'javascript:void(0)';
          anchor.rel = 'nofollow';
          anchor.className = 'icon-wishlist-heart-empty wishlist-btn grid-wishlist-btn heart-wishlist-animation';
          anchor.setAttribute('data-wishList', '');
          anchor.setAttribute('data-gridHulkList', '');
          anchor.setAttribute('data-added', 'false');
          anchor.setAttribute('data-proID', productId);
          anchor.setAttribute('data-varID', variantId);
          anchor.setAttribute('aria-label', 'お気に入りに追加');
          anchor.title = 'お気に入りに追加';
          anchor.innerHTML =
            '<div style="display: initial;" class="wishlist_btn_icon"><i class="heart-hulk-animation"><i class="icon-wishlist-heart-empty"></i></i></div><span>Add to wishlist</span><span class="count">0</span>';
          wishlistSlot.appendChild(anchor);
        });

        if (inactiveScope) {
          inactiveScope.querySelectorAll(buttonSelector).forEach((button) => button.remove());
        }
      }

      getActiveWishlistScope() {
        const isMobile = this.mobileMql && this.mobileMql.matches;
        const isModalOpen = this.modal && this.modal.classList.contains('is-open');
        if (isMobile && isModalOpen && this.modal) return this.modal;
        if (this.inlinePanel) return this.inlinePanel;
        return this;
      }

      getInactiveWishlistScope() {
        const activeScope = this.getActiveWishlistScope();
        if (!this.modal) return null;
        if (activeScope === this.modal) return this.inlinePanel || null;
        return this.modal;
      }

      refreshWishlistButtons() {
        this.ensureWishlistButtons();
        const isDesktop = !this.mobileMql || !this.mobileMql.matches;
        const emptyHeart =
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 20.7 4.6 13.8A4.75 4.75 0 1 1 11.3 7l.7.7.7-.7a4.75 4.75 0 1 1 6.7 6.8L12 20.7Z'/%3E%3C/svg%3E\")";
        const filledHeart =
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black'%3E%3Cpath d='M12 20.7 4.6 13.8A4.75 4.75 0 1 1 11.3 7l.7.7.7-.7a4.75 4.75 0 1 1 6.7 6.8L12 20.7Z'/%3E%3C/svg%3E\")";

        const applyStyleOnly = () => {
          if (this.hasMissingWishlistButtons()) {
            this.ensureWishlistButtons();
          }

          this.getWishlistButtons().forEach((button) => {
            const slot = button.closest('.cedre-sku-quick-add__wishlist-slot');
            if (!slot) return;
            const isAdded = this.isWishlistAdded(button);

            button.style.setProperty('display', 'inline-flex', 'important');
            button.style.setProperty('visibility', 'visible', 'important');
            button.style.setProperty('opacity', '1', 'important');
            button.style.setProperty('background-repeat', 'no-repeat', 'important');
            button.style.setProperty('background-position', 'center', 'important');
            button.style.setProperty('background-size', '2.3rem 2.3rem', 'important');
            button.style.setProperty('background-image', isAdded ? filledHeart : emptyHeart, 'important');
            button.style.setProperty('font-size', '0', 'important');
            button.style.setProperty('line-height', '0', 'important');

            if (!isDesktop) return;

            button.classList.remove('style_1');
            button.style.setProperty('position', 'static', 'important');
            button.style.setProperty('top', 'auto', 'important');
            button.style.setProperty('right', 'auto', 'important');
            button.style.setProperty('bottom', 'auto', 'important');
            button.style.setProperty('left', 'auto', 'important');
            button.style.setProperty('transform', 'none', 'important');
            button.style.setProperty('margin', '0', 'important');
            button.style.setProperty('align-items', 'center', 'important');
            button.style.setProperty('justify-content', 'center', 'important');

            if (!slot) return;
            slot.style.setProperty('display', 'inline-flex', 'important');
            slot.style.setProperty('align-items', 'center', 'important');
            slot.style.setProperty('justify-content', 'center', 'important');
            slot.style.setProperty('line-height', '0', 'important');
          });

          this.syncRestockButtons();
        };

        if (this.wishlistDisplayTimer) {
          window.clearTimeout(this.wishlistDisplayTimer);
          this.wishlistDisplayTimer = null;
        }

        applyStyleOnly();
        let count = 0;
        const tick = () => {
          applyStyleOnly();
          count += 1;
          if (count >= 30) {
            this.wishlistDisplayTimer = null;
            return;
          }
          this.wishlistDisplayTimer = window.setTimeout(tick, 200);
        };
        tick();
      }

      isWishlistAdded(button) {
        const className = button.className || '';
        const action = (button.dataset.action || '').toLowerCase();
        const forceAdded = button.dataset.cedreForceAdded;

        if (forceAdded === '1') return true;
        if (forceAdded === '0') return false;

        return (
          button.dataset.added === 'true' ||
          button.dataset.added === '1' ||
          action === 'remove' ||
          action === 'added' ||
          /(\bis-added\b|\bwishlist-added\b|\badded\b)/.test(className)
        );
      }

      hasMissingWishlistButtons() {
        const scope = this.getActiveWishlistScope();
        if (!scope) return false;

        const rows = scope.querySelectorAll('.cedre-sku-quick-add__row[data-variant-id][data-product-id]');
        for (const row of rows) {
          const slot = row.querySelector('.cedre-sku-quick-add__wishlist-slot');
          if (!slot) continue;
          if (!slot.querySelector('a.wishlist-btn, a[data-wishlist], a[data-wishList]')) {
            return true;
          }
        }
        return false;
      }

      getWishlistButtons() {
        const selectors =
          '.cedre-sku-quick-add__actions a.wishlist-btn, .cedre-sku-quick-add__actions a[data-wishlist], .cedre-sku-quick-add__actions a[data-wishList]';
        return [...this.getActiveWishlistScope().querySelectorAll(selectors)];
      }

      syncRestockButtons() {
        const rows = this.getActiveWishlistScope().querySelectorAll('.cedre-sku-quick-add__row');
        rows.forEach((row) => {
          const trigger = row.querySelector('[data-restock-trigger]');
          if (!trigger) return;

          const label = trigger.querySelector('[data-restock-label]');
          const defaultLabel = trigger.dataset.restockDefaultLabel || '';
          const addedLabel = trigger.dataset.restockAddedLabel || defaultLabel;
          if (trigger.dataset.restockLoginUrl) {
            trigger.classList.remove('is-added');
            if (label) label.textContent = defaultLabel;
            return;
          }
          const wishlistProxy = row.querySelector(
            '.cedre-sku-quick-add__wishlist-slot a.wishlist-btn, .cedre-sku-quick-add__wishlist-slot a[data-wishlist], .cedre-sku-quick-add__wishlist-slot a[data-wishList]'
          );
          const isAdded = wishlistProxy ? this.isWishlistAdded(wishlistProxy) : false;

          trigger.classList.toggle('is-added', isAdded);
          if (label) label.textContent = isAdded ? addedLabel : defaultLabel;
        });
      }

      closePanel() {
        if (!this.modal) return;
        this.modal.classList.remove('is-open');
        document.removeEventListener('keydown', this.onEsc);
        this.updateStickyVisibility();
      }

      handleEsc(event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.closePanel();
        }
      }

      async onAddToCart(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        if (!variantId || button.classList.contains('is-loading') || button.disabled) return;

        const row = button.closest('.cedre-sku-quick-add__row');
        const feedback = row ? row.querySelector('[data-sku-feedback]') : null;
        const label = button.querySelector('[data-sku-button-label]');
        if (label && !button.dataset.defaultLabel) {
          button.dataset.defaultLabel = label.textContent || '';
        }
        if (!button.dataset.fixedWidth) {
          button.dataset.fixedWidth = `${button.offsetWidth}px`;
          button.style.width = button.dataset.fixedWidth;
        }
        const defaultLabel = button.dataset.defaultLabel || '';

        this.updateFeedback(feedback, '');
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('disabled', 'disabled');
        if (label && button.dataset.addingLabel) label.textContent = button.dataset.addingLabel;

        try {
          const response = await this.requestAddToCart(variantId);
          if (response.status) {
            throw new Error(response.description || response.message || button.dataset.failedLabel);
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cedre-sku-quick-add',
              productVariantId: variantId,
              cartData: response,
            });
          }
          this.cart.renderContents(response);
          this.updateFeedback(feedback, button.dataset.addedLabel, 'is-success');
        } catch (error) {
          this.updateFeedback(feedback, error.message || button.dataset.failedLabel, 'is-error');
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          button.removeAttribute('disabled');
        if (label) label.textContent = defaultLabel;
      }
      }

      async requestAddToCart(variantId) {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        return response.json();
      }

      updateFeedback(target, message, stateClass) {
        if (!target) return;
        target.classList.remove('is-success', 'is-error');
        target.textContent = message || '';
        if (stateClass) target.classList.add(stateClass);
      }

      bindStickyObserver() {
        if (!this.openButton || !this.stickyWrap || !('IntersectionObserver' in window)) return;

        this.primaryObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.isPrimaryVisible = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
            this.updateStickyVisibility();
          },
          { threshold: [0, 0.01] }
        );

        this.primaryObserver.observe(this.openButton);
      }

      bindViewportListener() {
        if (!this.mobileMql) return;

        if (typeof this.mobileMql.addEventListener === 'function') {
          this.mobileMql.addEventListener('change', this.onViewportChange);
          return;
        }

        if (typeof this.mobileMql.addListener === 'function') {
          this.mobileMql.addListener(this.onViewportChange);
        }
      }

      unbindViewportListener() {
        if (!this.mobileMql) return;

        if (typeof this.mobileMql.removeEventListener === 'function') {
          this.mobileMql.removeEventListener('change', this.onViewportChange);
          return;
        }

        if (typeof this.mobileMql.removeListener === 'function') {
          this.mobileMql.removeListener(this.onViewportChange);
        }
      }

      updateStickyVisibility() {
        if (!this.stickyWrap) return;

        const isMobile = !this.mobileMql || this.mobileMql.matches;
        const isModalOpen = Boolean(this.modal && this.modal.classList.contains('is-open'));
        const shouldShow = isMobile && !this.isPrimaryVisible && !isModalOpen && !this.isFooterVisible;

        this.stickyWrap.classList.toggle('is-visible', shouldShow);
      }

      handleViewportChange() {
        this.ensureWishlistButtons();
        this.refreshWishlistButtons();
        this.updateStickyVisibility();
      }

      bindFooterObserver() {
        if (!this.footerSection || !this.stickyWrap || !('IntersectionObserver' in window)) return;

        this.footerObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.isFooterVisible = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
            this.updateStickyVisibility();
          },
          { threshold: [0, 0.01] }
        );

        this.footerObserver.observe(this.footerSection);
      }
    }
  );
}
